module.exports = __webpack_public_path__ + "img/trinidad-and-tobago.9ecf6e7f.png";